export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="bg-foreground-900 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
                随时随地，畅享高清观影
              </h2>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-8 max-w-md mx-auto lg:mx-0">
                极速影视全面适配手机、平板与电脑端，无论在家还是路上，打开浏览器即可畅享海量高清大片。
                无需下载APP，网页即开即看，极速加载不缓冲。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="w-full sm:w-auto px-6 py-3 bg-accent-500 hover:bg-accent-400 text-foreground-950 font-semibold rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
                >
                  <i className="ri-smartphone-line mr-2"></i>手机端立即体验
                </a>
                <a
                  href="#hero"
                  className="w-full sm:w-auto px-6 py-3 border border-foreground-600 hover:border-accent-400 text-foreground-300 hover:text-accent-400 font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
                >
                  <i className="ri-computer-line mr-2"></i>电脑端观影指南
                </a>
              </div>
            </div>
            <div className="flex-1 flex justify-center p-6 md:p-10">
              <div className="relative w-[200px] h-[400px] sm:w-[220px] sm:h-[440px] rounded-3xl overflow-hidden border-2 border-foreground-700">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20mockup%20showing%20a%20cinematic%20movie%20browsing%20interface%20with%20dark%20theme%2C%20film%20poster%20thumbnails%2C%20elegant%20minimal%20UI%2C%20warm%20golden%20accents%2C%20professional%20streaming%20app%20look%2C%20no%20text%20no%20people&width=440&height=880&seq=app-mockup-01&orientation=portrait"
                  alt="极速影视移动端观影界面"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}